import { formatTimeAgo, formatViews, formatDuration } from "../utils/helper";



const VideoCard = ({ info }) => {
  // console.log(info);
  const { snippet, statistics, contentDetails } = info;
  const { title, channelTitle, thumbnails, publishedAt } = snippet;

  return (
    <div className="w-full transition-all hover:shadow-lg rounded-lg cursor-pointer">
      <div className="relative aspect-video bg-gray-200 rounded-t-lg overflow-hidden">
        <img
          className="w-full rounded-t-lg"
          src={thumbnails.medium.url}
          alt={title}
        />
        <span className="absolute bottom-1 right-1 bg-black text-white px-2 py-1 text-xs rounded-md">
          {formatDuration(contentDetails?.duration)}
        </span>
      </div>

      <div className="p-3">
        <h1 className="font-semibold text-sm line-clamp-2 mb-2">{title}</h1>
        <div className="flex flex-col text-gray-600">
          <span className="text-sm">{channelTitle}</span>
          <div className="text-xs flex gap-2">
            <span>{formatViews(statistics?.viewCount)} views</span>
            <span>•</span>
            <span>{formatTimeAgo(publishedAt)}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoCard